export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/b7f7b288dfea02dba26459a2a7b68aed.png";